import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Column, Table, ExpandedState, useReactTable, getCoreRowModel, getFilteredRowModel, getExpandedRowModel, getSortedRowModel, ColumnDef, flexRender } from "@tanstack/react-table";
import config from "config";
import { Button, ButtonGroup, Divider, HorizontalLayout, Dropdown, SubMenu } from "../../BaseComponents";
import { Input, Modal } from "antd";
import { DownOutlined, RightOutlined, UpOutlined, ProjectOutlined } from "@ant-design/icons";
import { DataMangagerTableWrap } from "../styles";
import { LockedByYou, LockedBySomeone, NotLocked, collab_columns, notes_columns } from "../../ProjectManager/CollabAssets";
import proj_data from "./fake_dm_data.json";
import three_dots from "../three_dots.svg";
import { canopyActions, inputsActions, projectActions, siftActions } from "../../Redux";

const format_date_ts = (timestamp, with_time=false) => {
  let date = new Date(timestamp * 1000);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  // let strTime = hours + ":" + minutes + " " + ampm;
  let strTime = `${hours}:${minutes}${ampm}`;
  let format_d = `${strTime} - ${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  let format_s = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  if (with_time) {
    return format_d.toString();
  }
  return format_s.toString();
};

const ButtonStateMachine = (project) => {
  // console.log('---',project)
  const dispatch = useDispatch();
  const [modal_visible, set_modal_visible] = useState({ visible: false, type: "load", temp_project_name: "", temp_variant_name: "" });
  const [loading, set_loading] = useState(false);

  const get_project_inputs = (save_as = false) => {
    // if (internal_sift && using_canopy) {
    //   save_project = {
    //     project_id: canopy.project_id,
    //     rectangles: canopy.canopies,
    //     shade_objects: canopy.shade_objects,
    //     images: canopy.images,
    //     project_name: canopy.project_name,
    //     module: inputs.mod_id,
    //     active: 2,
    //     project_type: 3,
    //     map_center: Object.values(canopy.canopies).length > 0 ? getSiteCenter(canopy.canopies) : inputs.map_center,
    //     uiState: { pm_modal_visible: false },
    //     locked_by_email: !save_as && projects.local[inputs.project_id]?.locked_by_email ? projects.local[inputs.project_id]?.locked_by_email : undefined,
    //     locked: !save_as && projects.local[inputs.project_id]?.locked ? projects.local[inputs.project_id]?.locked : undefined,
    //     locked_by_me: !save_as && projects.local[inputs.project_id]?.locked_by_me ? projects.local[inputs.project_id]?.locked_by_me : undefined,
    //     collab_on: !save_as && projects.local[inputs.project_id]?.collab_on ? projects.local[inputs.project_id]?.collab_on : undefined,
    //     creator: !save_as && projects.local[inputs.project_id]?.creator ? projects.local[inputs.project_id]?.creator : undefined,
    //     user_list: !save_as && projects.local[inputs.project_id]?.user_list ? projects.local[inputs.project_id]?.user_list : undefined,
    //     notes: !save_as && projects.local[inputs.project_id]?.notes ? projects.local[inputs.project_id]?.notes : undefined,
    //   };
    // } else if (internal_sift) {
    //   save_project = {
    //     ...inputs,
    //     edited_layouts: {},
    //     project_id: inputs.project_id,
    //     project_name: inputs.project_name,
    //     project_type: 1,
    //     active: 1,
    //     images: canopy.images,
    //     en_target_inputs: en_target_inputs,
    //     site_features: inputs.site_features,
    //     shade_objects: canopy.shade_objects,
    //     racking_errors: undefined,
    //     ground_saved_state: undefined,
    //     canopy_saved_state: undefined,
    //     locked_by_email: !save_as && projects.local[inputs.project_id]?.locked_by_email ? projects.local[inputs.project_id]?.locked_by_email : undefined,
    //     locked: !save_as && projects.local[inputs.project_id]?.locked ? projects.local[inputs.project_id]?.locked : undefined,
    //     locked_by_me: !save_as && projects.local[inputs.project_id]?.locked_by_me ? projects.local[inputs.project_id]?.locked_by_me : undefined,
    //     collab_on: !save_as && projects.local[inputs.project_id]?.collab_on ? projects.local[inputs.project_id]?.collab_on : undefined,
    //     creator: !save_as && projects.local[inputs.project_id]?.creator ? projects.local[inputs.project_id]?.creator : undefined,
    //     user_list: !save_as && projects.local[inputs.project_id]?.user_list ? projects.local[inputs.project_id]?.user_list : undefined,
    //     notes: !save_as && projects.local[inputs.project_id]?.notes ? projects.local[inputs.project_id]?.notes : undefined,
    //   };
    // } else {
    // }
    let save_project = {
      ...project.original,
      edited_layouts: {},
      project_id: project.original.project_id,
      project_name: project.original.project_name,
      project_type: 1,
      active: 1,
      images: {},
      // en_target_inputs: en_target_inputs,
      site_features: project.original.site_features,
      shade_objects: {},
      racking_errors: undefined,
      ground_saved_state: undefined,
      canopy_saved_state: undefined,
      locked_by_email: !save_as && projects.local[project.original.project_id]?.locked_by_email ? projects.local[project.original.project_id]?.locked_by_email : undefined,
      locked: !save_as && projects.local[project.original.project_id]?.locked ? projects.local[project.original.project_id]?.locked : undefined,
      locked_by_me: !save_as && projects.local[project.original.project_id]?.locked_by_me ? projects.local[project.original.project_id]?.locked_by_me : undefined,
      collab_on: !save_as && projects.local[project.original.project_id]?.collab_on ? projects.local[project.original.project_id]?.collab_on : undefined,
      creator: !save_as && projects.local[project.original.project_id]?.creator ? projects.local[project.original.project_id]?.creator : undefined,
      user_list: !save_as && projects.local[project.original.project_id]?.user_list ? projects.local[project.original.project_id]?.user_list : undefined,
      notes: !save_as && projects.local[project.original.project_id]?.notes ? projects.local[project.original.project_id]?.notes : undefined,
    };
  
    // ensure that the pm_modal_visible isn't saved as true when the save modal is open.
    // If it is saved as true, it causes issues with editing
    // polygons in the map right after loading a project as several
    // functions in the map check to see if a modal is open, i.e search, hotkeys etc.
    // save_project.uiState.pm_modal_visible = false;
    // if (!internal_sift && !using_canopy) {
    // }
    return save_project;
  };
  

  const load_variant = () => {
    set_loading(true);
    console.log("loading variant", project.original);
    dispatch(projectActions.load_project(project.original));
  
    // if project is not locked, meaning it's not out by someone else, then check it out.
    if (project.original.collab_on == 1 && !project.original.locked) {
      console.log("checking out project", project.original);
      // check_in_collab(false, project_id_to_load, false);
    }  
    set_loading(false);
  }

  const save_as_ = () => {
    if (modal_visible.type == "saveasvariant" && modal_visible.temp_variant_name.length == 0) {
      return;
    }
    if (modal_visible.type == "saveasproject" && modal_visible.temp_variant_name.length == 0 && modal_visible.temp_project_name.length == 0) {
      return;
    }    
    set_loading(true);
    console.log("save_as_", modal_visible.type, modal_visible.temp_project_name);
    // set_modal_visible({ visible: true, type: "saveas" });

    let _inputs = {...project.original};
    // name has been entered
    if (modal_visible.type == "saveasvariant") {
      _inputs.variant_id = undefined;
    }
    if (modal_visible.type == "saveasproject") {
      _inputs.project_id = undefined;
      _inputs.variant_id = undefined;
      _inputs.project_name = modal_visible.temp_project_name;
      // _inputs.new_project = true;
      dispatch(inputsActions.update_input("project_name", modal_visible.temp_project_name));
    }    
    _inputs.variant_name = modal_visible.temp_variant_name;
    dispatch(inputsActions.update_input("variant_name", modal_visible.temp_variant_name));
    dispatch(projectActions.update_project(_inputs, modal_visible.type));
    // open_modal(false, "saveas");
    // set_selected_project_id(undefined); 
    set_loading(false);
    onCloseModal();
  }

  const save_as_new_project = () => {

    // set_modal_visible({ visible: true, type: "savenew" });
    // let _inputs = get_project_inputs(true);
    // name has been entered
    // save_as_project_inputs.project_id = undefined;
    // save_as_project_inputs.project_name = temp_project_name;
    // dispatch(inputsActions.update_input("project_name", temp_project_name));
    // dispatch(projectActions.update_project(_inputs));
    // open_modal(false, "saveas");
    // set_selected_project_id(undefined);    
  }

  const collab_project = () => {
    dispatch(inputsActions.update_ui_state("collab_modal_visible", { visible: true, project_id: project.original.project_id })); 
  }
  const delete_project = () => {
    let _inputs = {...project.original};
    _inputs.active = 0;
    _inputs.variant_id = undefined;
    // console.log("delete_project_inputs", delete_project_inputs);
    // new_project();
    dispatch(projectActions.update_project(_inputs, "delete_variant"));
    // set_selected_project_id(undefined);    
  }
  const delete_variant = () => {
    let _inputs = {...project.original};
    _inputs.active = 0;
    // console.log("delete_project_inputs", delete_project_inputs);
    // new_project();
    dispatch(projectActions.update_project(_inputs, "delete_variant"));
    // set_selected_project_id(undefined);
  }
  const onCloseModal = () => {
    // dispatch(inputsActions.update_ui_state("disable_hotkeys", false))
    set_modal_visible({ visible: false, type: "saveas", temp_project_name: "", temp_variant_name: "" })
  }
  const onOpenModal = (_type) => { 
    // dispatch(inputsActions.update_ui_state("disable_hotkeys", true))
    set_modal_visible({ visible: true, type: _type, temp_project_name: "", temp_variant_name: "" });
  }
  const onUpdateProjectName = (e) => {
    set_modal_visible({ ...modal_visible, temp_project_name: e.target.value });
  }
  const onUpdateVariantName = (e) => {
    set_modal_visible({ ...modal_visible, temp_variant_name: e.target.value });
  }  
  

  return (
    <div key="buttonState">
    {project.depth == 0 ? 
      <HorizontalLayout>
          {/* <Button type="link" size="small" label="Collaborate" /> */}
          <Dropdown
            placement="bottomRight"
            overlay={
              <ul>
                <li key="collab_project" id="collab_proj" onClick={collab_project}>
                  Collaborate
                </li>              
                <li key="del_all_proj" id="delete_proj" style={{ color: "var(--error)" }} onClick={delete_project}>
                  Delete Project
                </li>
              </ul>
            }
          >
            <Button type="ghost" size="small">
            <img src={three_dots} alt="Actions" style={{height: '10px', marginTop: '10px'}}/>
            </Button>
          </Dropdown>
        </HorizontalLayout>  
      : 
        <Dropdown
            placement="bottom"
            overlay={
              <ul>
                <li key="load_proj" id="load_proj" onClick={load_variant}>
                  Load
                </li>
                {/* <li key="variant_sub" id="save_as_variant" onClick={() => onOpenModal("saveasvariant")}>
                  Save As Variant
                </li>
                <li key="project_sub" id="save_as_project" onClick={() => onOpenModal("saveasproject")}>
                  Save As Project
                </li> */}
                <li key="del_variant" id="delete_variant" style={{ color: "var(--error)" }} onClick={delete_variant}>
                  Delete Variant
                </li>
              </ul>
            }
          >
            <HorizontalLayout>
              <Button
                size="small"
                type="secondary"
                // label={`Actions`}
                // onClick={(e) => {
                //   console.log("datamanager row clicked", row);
                //   // load_proj_click(e, row.original.project_id);
                // }}
              >
                {/* <DownOutlined /> */}
                <img src={three_dots} alt="Actions" style={{height: '10px', marginTop: '10px'}}/>
              </Button>
              {/* <Button type="secondary" size="small" label={<DownOutlined />} /> */}
            </HorizontalLayout>
          </Dropdown>
    }
    <Modal
      key="name-modal"
      className="sift-modal"
      closable={true}
      mask={false}
      open={modal_visible.visible}
      cancelText="Close"
      okText="Save"
      title="Save As"
      maskClosable={false}
      width={"25%"}
      onCancel={onCloseModal}
      onOk={save_as_}
      // footer={[
      //     <Button label="Save" size="small" onClick={save_as_} loading={loading} type="primary" key="save"/>
      // ]}            
    >
      <div style={{ overflowX: "auto" }}>
        <div style={{ padding: "2%" }}>
        {modal_visible.type == "saveasproject"
          &&
          <Input
            id="temp_project_name"
            disabled={loading}
            className="login-input"
            // ref={(input) => input && input.focus()}
            prefix={<ProjectOutlined type="text" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="Enter project name."
            value={modal_visible.temp_project_name}
            // value={project_name}
            onChange={(e) => onUpdateProjectName(e)}
            // onPressEnter={save_as_}
          />
        }
          <div style={{height: '10px'}}></div>
          <Input
            id="temp_variant_name"
            disabled={loading}
            className="login-input"
            // ref={(input) => input && input.focus()}
            prefix={<ProjectOutlined type="text" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="Enter variant name."
            value={modal_visible.temp_variant_name}
            // value={variant_name}
            onChange={e => onUpdateVariantName(e)}
            // onPressEnter={save_as_}
          />          
        </div>
      </div>        
    </Modal>   
    </div>
  )
};

const DataManagerTable = ({ projects, open_modal }) => {
  
  const using_canopy = window.location.pathname == "/canopy" || window.location.pathname == "/canopy/";
  const [expanded, setExpanded] = useState({});


  const data = useMemo(() => {
    if (_.isUndefined(projects)) {
      return [];
    }
    // console.log(projects);
    let local_projs = {};
    // loop through projects and add 3 properties to each project and then add to local_projs
    // 1. parent: true/false
    // 2. subRows: []
    // 3. project_type: 1/2/3
    Object.keys(projects).map(function (key) {
      let project = projects[key];
      let skip_proj = (!using_canopy && project.project_type == 3) || (using_canopy && project.project_type != 3);
      if (skip_proj) {
        return;
      }
      project.variants = Object.values(project.variants);
      project.parent = true;
      // project.subRows = project.subRows ? project.subRows : project.variants || [];
      // project.subRows = project.variants;
      local_projs[key] = project;
    });

    local_projs = Object.values(local_projs);
    // console.log(local_projs);
    return local_projs;
  }, [projects]);

  const toggleAllRowsExpanded = () => {
    const isAllExpanded = Object.values(expanded).every((value) => value);
    const newExpandedState = {};
    Object.keys(expanded).forEach((key) => {
      newExpandedState[key] = !isAllExpanded;
    });
    setExpanded(newExpandedState);
  };

  const toggleRowExpanded = (rowId) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [rowId]: !prevExpanded[rowId],
    }));
  };

  const columns = useMemo(
    () => [
      {
        id: "expander",
        accessorKey: "project_name",
        size: 300,
        header: "Project Name",
        cell: ({ row }) => (
          <>
          {/* {console.log(row.original)} */}
          {row.getCanExpand() ? (
            <div
              onClick={row.getToggleExpandedHandler()}
            >       
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Button type="link" label={row.getIsExpanded() ? <DownOutlined /> : <RightOutlined />} />
                <>{' '}{row.original.project_name}</>
              </div>
            </div>
          ) : (
            <div              
              style={{
              paddingLeft: `${row.depth * 3}rem`,
            }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}>
                <>{row.original.variant_name}</>              
              </div>
            </div>
          )}
          </>
        ),
      },
      {
        id: "status",
        size: 70,
        header: "Status",
        accessorKey: "status",
        cell: ({ row }) => (
          <div>
            {row.original.collab_on==1 ? 
              <>
                {row.original.locked_by_me ? LockedByYou : row.original.locked ? LockedBySomeone(row.original.locked_by_email) : NotLocked}
              </> :
              <Divider width={"20px"} />
            }
            {/* {row.getCanExpand() ? (
              <Divider width={"20px"} />
            ) : (
              <>
                {row.original.collab_on==1 && 
                  <>
                    {row.original.locked_by_me ? LockedByYou : row.original.locked ? LockedBySomeone(row.original.locked_by_email) : NotLocked}
                  </>
                }
                
              </>
            )}  */}
          </div>
        ),
      },
      // {
      //   id: "variants",
      //   size: 60,
      //   header: "Variants",
      //   accessorKey: "subRows",
      //   cell: (cell) => (cell.row.depth == 0 ? <>{cell.row.originalSubRows.length}</> : <Divider width={"35px"} />),
      // },
      {
        id: "modified_dated",
        size: 130,
        header: "Modified Date",
        accessorKey: "edit_dt",
        canFilter: false,
        // cell: (cell) => (!cell.row.original.parent && cell.getValue() ? format_date_ts(cell.getValue()) : null),
        cell: (cell) => (!cell.row.original.parent && cell.getValue() ? format_date_ts(cell.getValue(), true) : format_date_ts(cell.getValue(), false)),
        // cell: (row) => console.log("Modified Date Row", row),
      },
      {
        id: "actions",
        size: 165,
        header: "Actions",
        cell: ({ row }) => ButtonStateMachine(row),
        // cell: ({ row }) => console.log("row", row),
      },
    ],
    [expanded]
  );

  const table = useReactTable({
    data,
    columns,
    state: {
      expanded,
    },
    onExpandedChange: setExpanded,
    getSubRows: (row) => row.variants,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <DataMangagerTableWrap>
      <table>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan} style={{ width: `${header.getSize()}px` }}>
                    {header.isPlaceholder ? null : <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id} style={{
                backgroundColor: row.depth!=0 && "#012bcb29",
              }}>
                {row.getVisibleCells().map((cell) => {
                  return <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </DataMangagerTableWrap>
  );
};

const Projects = (props) => {
  const projects = useSelector((state) => state.projects);
  console.log("rendering projects", projects);
  // console.log("projectdata", proj_data);
  return <DataManagerTable projects={{...projects.local}} />;
};
export { Projects };
